import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined'
import StarBorderOutlined from '@material-ui/icons/StarBorderOutlined'
import StarOutlined from '@material-ui/icons/StarOutlined'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {Trans} from 'react-i18next'
import messages from '../../../../assets/messages'
import {config} from '../../../../config'
import {PammOfferType} from '../../../../graphql/types'
import {useMainOffer} from '../../MainOfferContext'
import {getOfferChainIds} from '../../utils/buildOfferTree'
import {KpiToggleButton} from './KpiToggleButton'
import {ActionButton, Actions} from './OfferCardActions.styled'

type OfferCardActionsProps = {
  offer: PammOfferType
}

/**
 * Actions for an offer card: Copy Link (copies the offer's join link
 * `?pammManager=&pammOffer=`) and the KPIs toggle (PT-5710). A manager's own root offer also gets
 * a button to mark it as the Main Offer, or to clear that mark (PT-6881). Agent offers never do:
 * the choice belongs to the manager, and the server refuses it for anything but a root.
 *
 * @param offer - The PAMM offer these actions operate on.
 */
export const OfferCardActions = ({offer}: OfferCardActionsProps) => {
  const joinLink = `${config.frontendUrl}?pammManager=${offer.skygroundAccountId}&pammOffer=${offer.id}`

  const mainOffer = useMainOffer()
  const isRoot = getOfferChainIds(offer).length === 0
  const isMainOffer = isRoot && mainOffer?.offerId === offer.id

  return (
    <Actions>
      {mainOffer && isRoot && (
        <ActionButton
          variant="outlined"
          size="small"
          disabled={mainOffer.saving}
          data-testid="main-offer-toggle"
          startIcon={isMainOffer ? <StarOutlined /> : <StarBorderOutlined />}
          onClick={() => mainOffer.onChange(isMainOffer ? null : offer.id)}
        >
          <Trans {...(isMainOffer ? messages.pammUnsetMainOffer : messages.pammSetMainOffer)} />
        </ActionButton>
      )}
      <KpiToggleButton offer={offer} />
      <CopyToClipboard text={joinLink}>
        <ActionButton variant="outlined" size="small" startIcon={<FileCopyOutlined />}>
          <Trans {...messages.copyLink} />
        </ActionButton>
      </CopyToClipboard>
    </Actions>
  )
}
